module.exports = __webpack_public_path__ + "img/dark-moon.f5f181d3.svg";